var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      key: _vm.id,
      staticClass:
        "material-input form-control material-input-static-label form my-1 moregage-data select-field",
      class: _vm.selectClassName,
      staticStyle: { display: "none" },
      attrs: {
        id: _vm.id,
        name: _vm.name,
        required: _vm.required,
        disabled: _vm.disabled,
      },
    },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "option",
        {
          key: index,
          attrs: { id: _vm.id },
          domProps: {
            value: item.value,
            selected: _vm.setSelectedOption(item),
          },
        },
        [_vm._v("\n    " + _vm._s(item.text) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }